import React from "react";
import "./Ourteam.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Ourteamheading from "./Ourteamheading";
import Ourteamimages from "./Ourteamimages";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import { Helmet } from "react-helmet-async";

function Ourteam() {
  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Our Team | Dwebbox</title>
        <link rel="canonical" href="https://dwebbox.com/ourteam" />
      </Helmet>
      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Ourteamheading />
      <Ourteamimages />
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Ourteam;
